import { Col, Row } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';

const InfoItem = ({ label, value, type = 'horizontal' }) => {
  return (
    <Row gutter={[16, 16]}>
      {label ? (
        <Col span={type === 'horizontal' ? 9 : 24}>
          <b>{label}: </b>
        </Col>
      ) : null}
      <Col span={type === 'horizontal' ? 15 : 24} className="text-start">
        {value}
      </Col>
    </Row>
  );
};

InfoItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
};

export default InfoItem;
